module.exports = __webpack_public_path__ + "media/bootstrap-icons/tsunami-d0a03111.svg";